// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"c8006eea","397":"db3849d4","784":"b4188e2f"}[chunkId] + ".chunk.css";
};